module.exports = __webpack_public_path__ + "img/lightjet2.969bf82a.png";